import { f as isFunction_1 } from "../../vendor-b303cd6e.mjs";
const resolveSlot = (slot) => {
  return slot && isFunction_1(slot) ? slot() : slot;
};
export {
  resolveSlot as r
};
//# sourceMappingURL=resolveSlot-f472b18c.mjs.map
